/**
 * Created by qingzhui on 16/12/31.
 */

require('../../scss/m/m-index.scss');

require('../../img/mobile/m-service-img1.jpg');
require('../../img/mobile/m-service-img2.jpg');
require('../../img/mobile/m-service-img3.jpg');
require('../../img/mobile/m-service-img4.jpg');
require('../../img/mobile/m-service-img1-en.png');
require('../../img/mobile/m-service-img2-en.png');
require('../../img/mobile/m-service-img3-en.png');
require('../../img/mobile/m-service-img4-en.png');

require('../../img/mobile/m-service-img6.jpg');
require('../../img/mobile/m-service-img10.jpg');
 
var common = require('./m-common');
var minioUrl = common.minioUrl;

var $ = require('jquery');
var arr = [
    {
        zh_title: '业务优势',
        en_title: 'Our Edge',
        zh_text:
    '借助华兴资本集团的生态系统，华兴新经济基金拥有无与伦比的行业网络和广泛的市场覆盖。同时，华兴具有为投资组合公司提供独特增值服务的能力，让多家中国新经济企业将其视为首选合作伙伴和准战略投资者。',
        en_text:
    'Huaxing Growth Capital enjoys an unparalleled industry network and extensive market coverage by leveraging the comprehensive resources provided by China Renaissance\'s platform. In addition, China Renaissance\'s ability to support its clients at every stage of their financial lifecycle has uniquely positioned the company as the partner of choice and strategic investor for new economy champions in China. ',
    },
    {
        zh_title: '资产管理规模',
        en_title: 'Assets Under Management',
        zh_text:
    '截至2024年12月31日，华兴投资管理业务的资产管理规模近人民币320亿元。',
        en_text:
    'As of December 31, 2024, China Renaissance Investment Management\'s assets under management (AUM) reached nearly RMB 32 billion.',
    },
    {
        zh_title: '投资人群体',
        en_title: 'Our Investors',
        zh_text:
    '基金的投资人包括国内和国际的各类机构投资人，如主权财富基金、政府机构、养老金、保险公司、银行、资产管理公司、FOF、家族理财办公室、企业/企业家等。',
        en_text:
    'China Renaissance’s Huaxing Growth Capital includes a diverse range of domestic and overseas institutional investors, including sovereign wealth funds, government agencies, pension funds, insurance companies, banks, asset managers, fund of funds, family offices and enterprises/entrepreneurs, among others.',
    },
    {
        zh_title: '投资策略',
        en_title: 'Investment Strategy',
        zh_text:
    '华兴新经济基金专注投资早期及成长期的企业。主要投资方向包括硬科技、人工智能、先进制造、医疗健康、新消费等领域。',
        en_text:
    'Huaxing Growth Capital focuses on investing in companies in the early and growth stages, concentrating on hard tech, artificial intelligence, advanced manufacturing, healthcare, and new consumption, among other transformative sectors.',
    },
    {
        zh_title: '领导团队',
        en_title: 'Leadership',  
        zh_text:  '<div> <div> <b>基金合伙人：</b>杜永波、辛耀州、虞洋</div><div> <b>董事总经理：</b>尹弘、邹彦书</div> </div>',
        en_text:
    '<span style="font-weight: bold">Partners:</span> Michael Du, John Hsin, Yang Yu<br><span style="font-weight: bold">Managing Directors:</span> Hong Yin, Yanshu Zou',
    },
    {
        zh_title: '投资案例',
        en_title: 'Our Notable Investments',
        zh_text:
    '<b>硬科技</b>：慧智微电子、纳微半导体、加特兰等<br><b>人工智能：</b>商汤、创新奇智等<br><b>先进制造：</b>理想汽车、蔚来汽车、经纬恒润等<br><b>医疗健康：</b>华大智造、药明康德、南微医学等<br><b>新消费：</b>美团、泡泡玛特、贝壳等',
        en_text:
    '<b>Hard Technologies:</b> Smarter Micro, Navitas, Calterah……<br><b>Artificial Intelligence:</b> SenseTime, AInnovation……<br><b>Advanced Manufacturing:</b> Li Auto, Nio, JINGWEI HIRAIN……<br><b>Smart Healthcare:</b> MGI, WuXi AppTec, Micro-Tech……<br><b>New Consumption:</b> Meituan, POP MART, BEKE……',
    },
];
var arrs = [
    {
        zh_title: '全球资产配置',
        en_title: 'Global Asset Allocation',
        zh_text:
    '<b>全球资产配置：</b>依托专业的全球宏观趋势分析，不断丰富的全球资产网络库，为客户提供全球资产配置。<br><b>优质投资管理能力：</b>以扎实的投研能力，优秀的投资团队，为客户提供多元化的定制服务。 ',
        en_text:
    '<b>Global Asset Allocation: </b>Provide clients with global asset allocation services by continuously expanding a network of global assets through macro trend analysis. <br><b>Best-in-Class Investment Management Capabilities:</b> Provide clients with diversified and tailored services through deep investment and research capabilities and supported by a strong investment team.',
    },
    {
        zh_title: '精选投资机会',
        en_title: 'Strategically Identify and Evaluate Investment Opportunities',
        zh_text:
    '基于华兴对成长期赛道的充分理解及独有的优秀资源池，我们能够在第一时间掌握优质资产机会，通过专业分析找到市场中的增长突破口，为客户进行资源匹配。<br><b>广泛地域覆盖：</b>在覆盖中国各新经济资产的同时，还涵盖美国，亚洲和欧洲及其他成长型区域资产。<br><b>全面行业覆盖：</b>除医疗，消费，科技等以新锐、成长为核心的资产领域外，着眼于提前探究下一代投资机会，如Web 3.0，科技创新、ESG等。<br><b>多样资产类别：</b>具有华兴特色的新经济资产，覆盖新锐绝对收益资产（新经济PE、 对冲基金，私募债基金），不动产基金、机会型基金等。',
        en_text:
    'Leveraging China Renaissance\'s proven track record and resource capabilities, the Wealth Management segment is able to advise clients how to optimize their asset allocations based on unique market opportunities.  <br> <b>Broad Geographic Coverage: </b>Products cover various smart economy assets in China, as well as assets in the United States, Asia, Europe and other regions.<br><b>Comprehensive Industry Coverage:</b> In addition to emerging, growth-focused asset classes (i.e., healthcare, consumer and technology), it also explores next-generation investment opportunities (i.e., Web 3.0, technology innovation and ESG).<br> <b>Diversified Asset Classes: </b>Smart Economy assets with unique characteristics, covering pioneer absolute return funds (Smart Economy PE, hedge funds, private debt funds), real estate funds, opportunistic funds, etc.',
    },
    {
        zh_title: '专业服务模式',
        en_title: 'Professional Service Framework',
        zh_text:
    '华兴财富管理拥有专业的顾问团队，除了提供日常的咨询服务外，还提供全行业领域的专业投研分析与建议。',
        en_text:
    'CR Wealth Management has a dedicated advisory team that provides not only daily wealth advisory services but also comprehensive cross-sector research with actionable recommendations.',
    },
    {
        zh_title: '高品质的活动',
        en_title: 'Other Valuable Investment Services',
        zh_text:
    '<b>投研咨询活动：</b>依托华兴资本集团的投研及投资网络，为我们的投资人长期提供各类贴近市场动态，行业观察等分享交流活动。<br><b>圈层交流分享：</b>不定期举办线下/线上交流活动，力求拓展投研之外的更多主题内容与我们的投资人进行分享，同时创造投资人间相互交流的机会。',
        en_text:
    '<b>Investment Research and Advisory:</b> Provides investors with market intelligence, industry insights and other sharing sessions through China Renaissance\'s research and investment teams.<br><b>Sharing Sessions:</b> Occasionally hosts sharing sessions through in-person and virtual meetings to provide investors with a platform where they can network and exchange market views, in addition to investment ideas.',
    },
];
var zhWWWDBuy7Text =
'华兴证券有限公司（曾用名“华菁证券有限公司”，以下简称“华兴证券”）是经中国证监会批准成立的全国性多牌照证券公司，也是根据《<内地与香港关于建立更紧密经贸关系的安排>(CEPA)补充协议十》设立的合资证券公司。';
var enWWWDBuy7Text =
'China Renaissance Securities Co., Ltd.(the Company) is a national, multi-licensed securities company approved by the China Securities Regulatory Commission(CSRC), which is also a joint venture founded in accordance with the Supplement X to Mainland and Hong Kong Closer Economic Partnership Arrangement(CEPA). ';
var zhWWWDBuy8Text =
'华兴证券的业务范围包括证券经纪、证券投资咨询、证券承销与保荐、证券资产管理、证券自营、代销金融产品。依托股东在境内外资本市场的布局及在新经济领域十余年的深厚积累，华兴证券致力于为新经济企业、金融机构、机构及个人投资者等各类客户提供多元化、一站式的综合金融服务，成为最优秀的服务中国新经济的投资银行。作为国内证券市场的新生力量，华兴证券将坚守合规底线、积极创造价值，助力中国新经济的成长与产业转型升级。';
var enWWWDBuy8Text =
'China Renaissance Securities\' business includes securities brokerage, securities investment consulting, securities underwriting and sponsorship, securities asset management, proprietary securities trading business, as well as distribution of financial products. With the support from our shareholders\' forward-looking plan in domestic and overseas capital markets, in addition to over ten years accumulated experience in Smart Economy sector, China Renaissance Securities is dedicated to becoming the best investment bank serving China\'s Smart Economy champions, financial institutions, as well as institutional and individual investors through comprehensive, diversified and one-stop financial services. As a new force in Chinese capital market, China Renaissance Securities continues to adhere to compliance requirements, generate returns, and support the growth of China\'s Smart Economy and industrial transformation.';
var zhWWWDBuy6Text =
'华兴财富管理以高效的“投行+私行”的团队服务模式，为客户提供一站式金融服务，陪伴在其企业，家族，个人守富、享富、传富的各个阶段。财富管理始终坚持客观、独立的视角，以优质、差异化资产管理能力，成为最受客户信赖的财富守卫者。';
var enWWWDBuy6Text =
'With an efficient "investment banking + private banking" service model, China Renaissance\'s Wealth Management segment provides its clients with one-stop financial services to support businesses, families and individuals at every stage of their wealth creation journey. China Renaissance\'s Wealth Management team adheres to an objective and independent approach, and has become the most trusted wealth advisor with high quality and differentiated asset management capabilities.';
var zhWWDinv =
'华兴新经济基金是华兴资本集团投资管理业务的核心产品。其使命是寻找未来的卓越企业并与之携手前行。新经济基金寻求为这些企业创造价值，并参与分享其价值创造。';
var enWWDinv =
'Huaxing Growth Capital is the flagship fund of CR\'s Investment Management segment and the principal private equity investment arm of China Renaissance. Its mission is to identify and partner with companies with significant growth potential and serve as a trusted partner to support and join their value creation journeys. ';
$(function () {
// document.addEventListener('touchstart', function(event){
//     event.preventDefault();
// }, {passive: false});

    // 获取当前语言环境
    var langInput = document.getElementById('lang');
    var lang = langInput ? langInput.value : undefined;

    var baseUrl = common.baseUrl();

    // 请求的所有地址
    var ajaxUrl = {
        caseList: baseUrl + 'v1/client?lang=' + (lang === 'en' ? 'en' : 'zh'), //例如 /api/case
    };

    // 请求私募案例数据
    getCaseList(ajaxUrl.caseList, lang, '私募融资案例', function (data) {
        var $ul1 = $('.m-case1 .list'),
            $ul2 = $('.m-case2 .list'),
            $ul3 = $('.m-case3 .list'),
            $ul4 = $('.m-case4 .list');

        var htm1 = '',
            htm2 = '',
            htm3 = '',
            htm4 = '';

        // 需要根据接口修改 字段名称 修改 images
        for (var i = 0; i < data.result.length; i++) {
            if (data.result[i].type == 'private-placement-transactions') {
                htm1 += '<li><img src="' + `${minioUrl + data.result[i].logo}` + '" alt=""></li>';
            } else if (data.result[i].type == 'm-a-transactions') {
                htm2 += '<li><img src="' + `${minioUrl + data.result[i].logo}` + '" alt=""></li>';
            } else if (data.result[i].type == 'ipo') {
                htm3 += '<li><img src="' + `${minioUrl + data.result[i].logo}` + '" alt=""></li>';
            } else if (data.result[i].type == 'investment-portfolio') {
                htm4 += '<li><img src="' + `${minioUrl + data.result[i].logo}` + '" alt=""></li>';
            }
        }

        $ul1.empty();
        $ul2.empty();
        $ul3.empty();
        $ul4.empty();
        // 私募融资案例已隐藏
        // $ul1.append(htm1);
        // $ul2.append(htm2);
        // $ul3.append(htm3);
        // $ul4.append(htm4);
    });

    function getCaseList(url, lang, type, callback) {
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            data: {
                // lang: lang,
                type: type, // 输入什么客户列表，如私募融资案例、并购案例、IPO案例、直投案例, 需要根据接口修改 字段名称
            },
            success: function (data) {
                if (data.result) {
                    // 成功进行回调
                    callback(data);
                } else {
                    // 错误，打印返回的数据分析情况
                    console.log(data);
                }
                callback(data);
            },
        });
    }
    // 添加类名
    if(lang==='en'){
        $('.m-securites button').addClass('enbtn')
    }else{
        $('.m-securites button').removeClass('enbtn')
    }
    // 添加中英文
    $('.m-service').prepend(
        lang === 'en' ? 
            `<div class="invest-texts">
                ${enWWDinv}
            </div>`
            :
            `<div class="invest-text">
                ${zhWWDinv}
            </div>`
    );
    $('.m-service1').prepend(lang==='en' ?
        `<div class="invest-texts">
            ${enWWWDBuy6Text}
        </div>`
        :
        `<div class="invest-text">
            ${zhWWWDBuy6Text}
        </div>`)
    $('.service4-text').append(lang === 'en' ? 
        `<div class="HX-foldings">
            <div class="HX-top">
                ${enWWWDBuy7Text}
            </div>
            <div class="HX-bottom">
                ${enWWWDBuy8Text}
            </div>`
    :
        `<div class="HX-folding">
            <div class="HX-top">
                ${zhWWWDBuy7Text}
            </div>
            <div class="HX-bottom">
                ${zhWWWDBuy8Text}
            </div>`
    );
    // 查看更多
    $('.m-private > img').on('click', function () {
        var childClass = lang === 'en' ? '.en-con' : '.cn-con';
        var dis = $(this).nextAll('.con:first').children(childClass).css('display');

        if (dis == 'none') {
            if (lang != 'en') {
                $(this).nextAll('.con:first').children(childClass).show();
            } else {
                $(this).nextAll('.con:first').children(childClass).show();
            }
        } else {
            $(this).nextAll('.con:first').children(childClass).hide();
        }
    });
//初始渲染
    $('.invest-folding').append(setinvestment(arr));
    $('.bond-folding').append(setinvestment(arrs, 'left'));
//展开栏点击事件
    for (let i = 0; i < arr.length; i++) {
        $(`.invest-folding .zhan${i}`).click(function () {
            if ($(`.invest-folding .zhan${i} .folding-text`).hasClass('active')) {
                $(`.invest-folding .zhan${i} .folding-text`).removeClass('active');
                $(`.invest-folding .zhan${i} .jia${i}`).removeClass('acts');
                $(`.invest-folding .zhan${i} .folding-text`).slideUp();
            } else {
                $('.invest-folding .folding-text').slideUp()
                $('.invest-folding svg').removeClass('acts')
                $(`.invest-folding .zhan${i} .folding-text`).addClass('active');
                $(`.invest-folding .zhan${i} .jia${i}`).addClass('acts');
                $(`.invest-folding .zhan${i} .folding-text`).slideDown(1000, function() {
        // $(`.invest-folding .zhan${i} .folding-text`).css('font-size', '32px');
                });
            }
        });
    }

    for (let i = 0; i < arrs.length; i++) {
        $(`.bond-folding .zhan${i}`).click(function () {
            if ($(`.bond-folding .zhan${i} .folding-text`).hasClass('active')) {
                $(`.bond-folding .zhan${i} .folding-text`).removeClass('active');
                $(`.bond-folding .zhan${i} .jia${i}`).removeClass('acts');
                $(`.bond-folding .zhan${i} .folding-text`).slideUp();
            } else {
                $('.bond-folding .folding-text').slideUp()
                $('.bond-folding svg').removeClass('acts')
                $(`.bond-folding .zhan${i} .folding-text`).addClass('active');
                $(`.bond-folding .zhan${i} .jia${i}`).addClass('acts');
                $(`.bond-folding .zhan${i} .folding-text`).slideDown(1000, function() {
        // $(`.bond-folding .zhan${i} .folding-text`).css('font-size', '32px');
                });
        
            }
        });
    }

//这个位置控制的是投资银行的位置点击显示的和隐藏
//  $('.m-mergers .btn-more').on('click', function () {
//      var dis = $(this).next().children().css('display');
//      console.log(123)
//      if (dis == 'none') {
//          if (lang != 'en') {
//              $(this).next().children('.cn-con').show();
//          } else {
//          	console.log("en lll")
//              $(this).next().children('.en-con').show();
//          }
//      } else {
//      	console.log("in")
//          $(this).next().children().hide();
//      }
//  });

    $('.showModal').click(function() {  
        var targetClass = $(this).attr('targetClass');

        var targetClassObj = $('.' + targetClass + '');
        var $body = $('body');

        targetClassObj.addClass('modal-open');
        $body.addClass('overflow-hidden');
        var modalOpen = document.getElementsByClassName('.modal-open')[0];

        if(modalOpen) {
            modalOpen.addEventListener('touchmove', (e) => e.preventDefault(), {passive: false})
    // $('.service').on('touchmove', function(e){
    //   e.preventDefault()
    // });
        }

    });
    $('.close-radius').click(function() { 

        var targetClassObj = $('.modal-open');
        console.log(targetClassObj,this)
        targetClassObj.removeClass('modal-open');
        var $body = $('body');

        $body.removeClass('overflow-hidden');
    // var modalOpen = document.getElementsByClassName('.service')[0];

    // modalOpen.removeEventListener('touchmove', (e) => e.preventDefault())

    });



//  $(".m-mergers ").on("click", function () {
//    var dis;
//    if (lang == "zh") {
//      dis = $(this).next().children(".cn-con").css("display");
//    } else {
//      dis = $(this).next().children(".en-con").css("display");
//    }
//    if (dis == "none") {
//      if (lang != "en") {
//        $(this).next().children(".cn-con").show();
//      } else {
//        //          	console.log("en lll")
//        $(this).next().children(".en-con").show();
//      }
//    } else {
//      //      	console.log("in")
//      $(this).next().children().hide();
//    }
//  });

//  $(".m-securites ").on("click", function () {
//    // FIXME: 先使用 input 来标明语言类型
//    var dis;
//    if (lang == "zh") {
//      dis = $(this).next().children(".cn-con").css("display");
//    } else {
//      dis = $(this).next().children(".en-con").css("display");
//    }

//    if (dis == "none") {
//      if (lang != "en") {
//        $(this).next().children(".cn-con").show();
//      } else {
//        $(this).next().children(".en-con").show();
//      }
//    } else {
//      $(this).next().children().hide();
//    }
//  });
//   初始渲染方法
    function setinvestment(arr, location) {
        var html = '';
        for (let i = 0; i < arr.length; i++) {
            html += `<div class="folding zhan${i} ${
        i === arr.length - 1 ? 'act' : ''
    }">
        <div class="foldings">
        ${
        location
            ? `<svg class="jia${i}" width="20" height="10" viewBox="0 0 24 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 2L12 12L22 2" stroke="#777777" stroke-width="4" stroke-miterlimit="10"/>
            </svg>
            <span>${
                lang === 'en' ? arr[i].en_title : arr[i].zh_title
            }</span>`
            : `<span>${
                lang === 'en' ? arr[i].en_title : arr[i].zh_title
            }</span><svg class="jia${i}" width="20" height="10" viewBox="0 0 24 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 2L12 12L22 2" stroke="#777777" stroke-width="4" stroke-miterlimit="10"/>
            </svg>`
        }
        </div> 
        <div class="folding-text">
        ${lang === 'en' ? arr[i].en_text : arr[i].zh_text}
        </div>
    </div>`;
        }
        return html;
    }
});
 


// WEBPACK FOOTER //
// ./src/m/m-services.js